<template>

    <div class="banner">
        <div class="banner__container">

            <div class="banner__content">
                <div class="banner__left">
                    <h2 class="banner__title">{{ t("banner2_title") }}</h2>
                    <p class="banner__text">{{ t("banner2_text") }}</p>
                    <div class="banner__buttons">
                        <a href="https://play.google.com/store/apps/details?id=com.vue.sbg" class="button" target="_blank">
                            <img src="@/assets/images/android.svg" :alt="t('banner2_android')"/>
                        </a>
                        <a href="https://apps.apple.com/us/app/%C5%9Bl%C4%85sk-bez-granic/id6448991949?platform=iphone" class="button" target="_blank">
                            <img src="@/assets/images/apple.svg" :alt="t('banner2_ios')"/>
                        </a>
                    </div>
                </div>

                <div class="banner__right">
                    <div class="banner__image">
                        <img src="@/assets/screen.png" :alt="t('banner2_preview')" class="_anim-items"/>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import Animation from "@/views/Components/Animation.vue";
import View from "@/views/View.vue"

export default {
    name: "Banner2",
    extends: View,
    mixins: [Animation]
}
</script>

<style scoped lang="scss">

.banner {
  background-color: rgb(73, 78, 155);
  z-index: 0;
  position: relative;

  &::before {
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    content: '';
    position: absolute;
    background-image: url("@/assets/banner2.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  &__container {
    max-width: 1140px;
    margin: 0 auto;
    padding: 0 12px;
  }

  &__content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 50px;

    @media screen and (max-width: 991px) {
      flex-direction: column;
    }
  }

  &__left {
    width: 100%;

    @media screen and (max-width: 991px) {
      text-align: center;
      margin: 30px 0 10px 0;
    }
  }

  &__right {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__title {
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 10px;
    color: #fff;
    font-size: 2.25rem;
  }

  &__text {
    margin-bottom: 30px;
    color: #fff;

    line-height: 1.575rem;
  }

  &__buttons {
    display: flex;
    flex-direction: row;
    gap: 15px;
    flex-wrap: wrap;

    @media screen and (max-width: 991px) {
      justify-content: center;
    }
  }

  &__image {
    margin-top: 70px;
    width: 380px;
    display: flex;
    align-items: end;
    justify-content: center;
    overflow: hidden;

    @media screen and (max-width: 991px) {
      margin-top: 0;
    }

    & > img {
      width: 100%;

      transform: translate(0px, 25%);

      &._active {
        opacity: 1;
        transform: translate(0px, 0px);
      }
    }
  }
}

.button {
  width: 145px;
  height: 42px;
  background-color: rgb(53 57 120);
  border-radius: 6px;
}

html.contrast {

  & .banner {
    background-color: gold;

    &__title {
      color: #000;
    }

    &__text {
      color: #000;
    }
  }

  & .button {
    background-color: darkgoldenrod;
  }
}

</style>